// Thin composition layer - re-exports from focused sub-modules
import * as dateUtils from './dateUtils';
import * as formatUtils from './formatUtils';
import * as sortUtils from './sortUtils';
import * as domUtils from './domUtils';
import * as dataUtils from './dataUtils';
import * as navigationUtils from './navigationUtils';

export const Utils = {
  // dateUtils
  formatDateObject: dateUtils.formatDateObject,
  formatCalenderDate: dateUtils.formatCalenderDate,
  parseDateToFormat: dateUtils.parseDateToFormat,
  convertDates: dateUtils.convertDates,
  compareDates: dateUtils.compareDates,
  convertToYYYYMMDD: dateUtils.convertToYYYYMMDD,
  convertDateToDisplayFormat: dateUtils.convertDateToDisplayFormat,
  calculateDaysLeft: dateUtils.calculateDaysLeft,

  // formatUtils
  formatCampaignTitle: formatUtils.formatCampaignTitle,
  numberToCurrencyString: formatUtils.numberToCurrencyString,
  isValidNumber: formatUtils.isValidNumber,
  getLocalCurrency: formatUtils.getLocalCurrency,
  formatNumberToUSDCurrency: formatUtils.formatNumberToUSDCurrency,

  // sortUtils
  sortStringAndBooleanValues: sortUtils.sortStringAndBooleanValues,
  sortDateValues: sortUtils.sortDateValues,
  sortNumber: sortUtils.sortNumber,
  sortString: sortUtils.sortString,
  sortDate: sortUtils.sortDate,

  // domUtils
  getValue: domUtils.getValue,
  onDateChange: domUtils.onDateChange,
  createDateInput: domUtils.createDateInput,
  assignInlineStyleOnRuntime: domUtils.assignInlineStyleOnRuntime,
  waitForElm: domUtils.waitForElm,
  displayTableSkeleton: domUtils.displayTableSkeleton,
  showDownloadModal: domUtils.showDownloadModal,
  exportToExcel: domUtils.exportToExcel,
  calculatetaxonomyWidth: domUtils.calculatetaxonomyWidth,
  splitByDelimiters: domUtils.splitByDelimiters,
  highlightDifferences: domUtils.highlightDifferences,

  // dataUtils
  getObjectFromArray: dataUtils.getObjectFromArray,
  createNestedArray: dataUtils.createNestedArray,
  createColumnsPayload: dataUtils.createColumnsPayload,
  swapJson: dataUtils.swapJson,
  findObjectByIdInNestedDataInAggridData: dataUtils.findObjectByIdInNestedDataInAggridData,
  transformAmounts: dataUtils.transformAmounts,
  disableHierarchyPublishButton: dataUtils.disableHierarchyPublishButton,
  removeDuplicateChildItems: dataUtils.removeDuplicateChildItems,
  convertSingleToDoubleQuotes: dataUtils.convertSingleToDoubleQuotes,
  sanitizeStringToValidJson: dataUtils.sanitizeStringToValidJson,
  sanitizeCookieName: dataUtils.sanitizeCookieName,
  checkForClientCodeAndBuyingSystem: dataUtils.checkForClientCodeAndBuyingSystem,

  // navigationUtils
  navigateToComponent: navigationUtils.navigateToComponent,
  setBaseUrl: navigationUtils.setBaseUrl,
  saveRouteChange: navigationUtils.saveRouteChange,
  getRouteParam: navigationUtils.getRouteParam,
};

